import { withTranslation } from "next-i18next";
import useCustomizableCloset from '@hooks/use-customizable-closet';
import { usePrice } from "@hooks/use-prices";

function ValidationSummary({ t }) {
  const price = usePrice();
  const { plan, add_ons_summary: addOnsSummary } = useCustomizableCloset();
  const addOnsToPayCount = addOnsSummary?.add_ons_count - addOnsSummary?.add_on_credits_to_spend;

  function planItemsDescription() {
    if (plan.swap_between_families) return t("common:drawer.modal_rtc.plans.swapable_families", { count: plan.clothes + plan.accessories });

    return t("common:drawer.modal_rtc.plans.accessory", { clothesCount: plan.clothes, count: plan.accessories })
  }

  return (
    <div className="p-3 bg-white">
      <p className="font-size-sm font-weight-bold text-uppercase">
        {t("common:drawer.modal_rtc.validate.summary.title")}
      </p>

      <div className="d-flex flex-column gap-2">
        <div className="d-flex justify-content-between">
          <p className="font-size-sm mb-0">
            {planItemsDescription()}
          </p>

          <p className="font-size-sm font-weight-bold mb-0">
            {t("common:drawer.modal_rtc.validate.summary.included")}
          </p>
        </div>

        <div className="d-flex justify-content-between">
          <p className="font-size-sm mb-0">
            {t("common:drawer.modal_rtc.validate.summary.shipping_fees")}
          </p>

          <p className="font-size-sm font-weight-bold mb-0">
            {t("common:drawer.modal_rtc.validate.summary.included")}
          </p>
        </div>

        {addOnsSummary?.add_on_credits_to_spend > 0 && (
          <div className="d-flex justify-content-between">
            <p className="font-size-sm mb-0">
              {t("common:drawer.modal_rtc.validate.summary.bonus_item", { count: addOnsSummary.add_on_credits_to_spend })}
            </p>

            <p className="font-size-sm font-weight-bold mb-0">
              {t("common:drawer.modal_rtc.change.add_on_counter.free", { count: addOnsSummary.add_on_credits_to_spend })}
            </p>
          </div>
        )}

        {addOnsToPayCount > 0 && (
          <div className="d-flex justify-content-between">
            <p className="font-size-sm mb-0">
              {t("common:drawer.modal_rtc.validate.summary.bonus_item", { count: addOnsToPayCount })}
            </p>

            <p className="font-size-sm font-weight-bold mb-0">
              {price(addOnsSummary.rest_to_pay)}
            </p>
          </div>
        )}
      </div>

      <div className="mt-3 pt-3 border-top border-light d-flex justify-content-between">
        <p className="font-weight-bold mb-0">
          {t("common:drawer.modal_rtc.validate.summary.total")}
        </p>

        <p className="font-weight-bold mb-0">
          {price(addOnsSummary?.rest_to_pay)}
        </p>
      </div>
    </div>
  );
}

export default withTranslation("common")(ValidationSummary);
